// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__aRvLu","copyrightItem":"Copyright_copyrightItem__glkzP"};